import Button from '@components/Button';
import Text from '@components/Text';
import styled from '@emotion/styled';
import React from 'react';

type Props = {
    children: React.ReactNode;
};

type State = {
    hasError: boolean;
    error?: Error;
};

class ErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error) {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        console.error('Caught by ErrorBoundary:', error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <Container>
                    <Text size='xl'>
                  오류가 발생하였습니다.
                    </Text>
                    <Button onClick={() => {
                        window.location.href = '/';
                    }}>
                  홈으로 돌아가기
                    </Button>
                </Container>
            );
        }
        return this.props.children;
    }
}

const Container = styled.div`
    display: flex;
    width: 100vw;
    height: 100vh;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

export default ErrorBoundary;
